/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VenueDetailsDto as DigiworkMaitreDDtoAdvertiserVenueDetailsDto } from '../../models/Digiwork/MaitreD/DTO/Advertiser/venue-details-dto';

export interface GetVenueDetails_1$Params {
  venueId?: string;
}

export function getVenueDetails_1(http: HttpClient, rootUrl: string, params?: GetVenueDetails_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDDtoAdvertiserVenueDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, getVenueDetails_1.PATH, 'get');
  if (params) {
    rb.query('venueId', params.venueId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDDtoAdvertiserVenueDetailsDto>;
    })
  );
}

getVenueDetails_1.PATH = '/api/gmn/Venue/getvenuedetails';
